<template>
    <v-card
        outlined
        class="!tw-rounded-lg !tw-border-gray-200 night:!tw-border-primary"
    >
        <v-card-text
            class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-1 !tw-rounded-lg !tw-p-4 tw-min-h-40"
        >
            <v-avatar size="40" class="tw-bg-gray-300">
                <span> {{ initials }}</span>
            </v-avatar>
            <div class="tw-flex tw-flex-col tw-items-center">
                <span
                    class="tw-text-base tw-text-center tw-font-medium tw-text-black night:tw-text-white"
                >
                    {{ props.account.fullName }}
                </span>
                <span class="tw-text-sm tw-font-normal tw-text-center">
                    {{ relationship }}
                </span>
            </div>

            <v-btn
                class="tw-flex tw-items-center"
                text
                @click="onDelete"
                v-if="!registered"
            >
                <v-icon class="icon" color="error" size="16">
                    mdi-delete-outline
                </v-icon>
                <span class="tw-text-sm tw-font-normal tw-text-red-500">
                    Remove
                </span>
            </v-btn>
        </v-card-text>
        <div
            class="tw-text-sm tw-font-normal tw-text-white tw-text-center tw-w-full tw-bg-green-500 tw-p-1"
            v-if="registered"
        >
            {{ $t('message.alreadyBooked') }}
        </div>
    </v-card>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { type AccountDetail } from '../api/getSubAccountsByUserApi'
import { AUTHENTICATION_MODULE_NAME } from '@/store/moduleNames'
import { useStore } from '@/util/vuex'
import {
    getRelationship,
    getInitials,
} from '@/modules/subAccounts/utils/subAccount'

const props = defineProps<{
    account: AccountDetail
    registered?: boolean
}>()
const emit = defineEmits(['onDelete'])

const store = useStore()
const user = computed(
    () => store.getters[`${AUTHENTICATION_MODULE_NAME}/getUser`]
)

const relationship = computed(() => {
    return getRelationship(props.account, user.value)
})

const initials = computed(() => {
    return getInitials(props.account)
})

const onDelete = () => {
    emit('onDelete', props.account)
}
</script>
